const apiUrl = 'https://backend.govedafoundation.org';
export default apiUrl;
